var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.showSpinner)?_vm._t("default",null,{"transition":"fade-transition"}):_vm._e(),(_vm.showSpinner)?_c('AsfLoadingSpinner',{staticStyle:{"z-index":"10000"},attrs:{"transition":"fade-transition"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }